var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92857 3.85713H8.03125M2.58036 1V1.85724M8.3125 1V1.85714M10 4.85714L10 8C10 9.65685 8.65685 11 7 11H4C2.34315 11 1 9.65685 1 8V4.85714C1 3.20028 2.34315 1.85714 4 1.85714H7C8.65685 1.85714 10 3.20028 10 4.85714Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenDateIcon);
export default __webpack_public_path__ + "static/media/Green_Date_Icon.7604e5cfc380722e749250c112e5b09f.svg";
export { ForwardRef as ReactComponent };